import { styled } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Title, useLoader } from 'thermia-react-container';
import ApprovalComponent from '../components/approvalComponent';
import BadgeList from '../components/badgeList';
import FeedbackComponent from '../components/feedbackComponent';
import GuideContent from '../components/guideContent';
import useTroubleshootService from '../service/useTroubleshootService';
import { GuideData, GuideType, TroubleshootTagData } from '../types/types';
import FooterComponent from "../components/footerComponent";

type props = {
  type: GuideType;
};

const TroubleshootView = ({ type }: props) => {
  const { id } = useParams();
  const { getGuideById, fetchTagdata } = useTroubleshootService();
  const [loading, setLoading] = useState<boolean>(false);
  const [guideData, setGuideData] = useState<GuideData | null>(null);
  const [tagData, setTagData] = useState<TroubleshootTagData>([]);
  const { Loader } = useLoader();
  const loadedIdRef = React.useRef<string>();
  const navigate = useNavigate();

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const fetchedTagData = await fetchTagdata(type);
      setTagData(fetchedTagData);
      const fetchGuideData = await getGuideById(Number(id));
      setGuideData(fetchGuideData);
      loadedIdRef.current = id;
    } catch (error: any) {
      if (error.status === 404) {
        navigate('/noGuide');
      }
    }
    setLoading(false);
  }, [fetchTagdata, getGuideById, id, navigate, type]);

  useEffect(() => {
    if (loadedIdRef.current !== id && !loading) {
      fetchData();
    }
  }, [fetchData, id, loading]);

  return !loading && loadedIdRef.current ? (
    guideData && (
      <>
        <Title text={guideData.heading} />
        <BadgeList item={guideData} tagData={tagData} expandable={true} limit={9} />
        <GuideContent guide={guideData} />
        <FooterComponent guide={guideData} />
        <ApprovalComponent guide={guideData} />
        <FeedbackComponent guide={guideData} />
      </>
    )
  ) : (
    <Loader />
  );
};

export default TroubleshootView;
